/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid, PageGridContainer, Typography } from '@coursera/cds-core';

import EnterpriseCareerJourneyCard from 'bundles/unified-career-academy/components/modules/EnterpriseCareerJourneyCard';

import _t from 'i18n!nls/career-academy';

function CareerJourneyModule() {
  const styles = {
    section: css`
      padding: var(--cds-spacing-600) 0;
      background-color: var(--cds-color-grey-25);
    `,
    journeyCardsContainer: css`
      margin-top: var(--cds-spacing-200);
    `,
  };

  return (
    <section css={styles.section}>
      <PageGridContainer>
        <Grid item xs={12}>
          <Typography variant="d2" css={{ fontWeight: 600 }} align="center" style={{ marginBottom: '16px' }}>
            {_t('Start your career journey with industry-leading, skills-first training that gets you job ready')}
          </Typography>
          <Typography variant="h2" align="center">
            {_t('No experience required. For career starters or switchers looking for in-demand, entry-level jobs.')}
          </Typography>
        </Grid>
        <Grid item xs={12} container spacing={48} css={styles.journeyCardsContainer}>
          <EnterpriseCareerJourneyCard />
        </Grid>
      </PageGridContainer>
    </section>
  );
}

export default CareerJourneyModule;
